
import {useEffect} from 'react';

import {useAppSelector} from 'stores/redux_store';
import {getCurrentUser} from 'mattermost-redux/selectors/entities/common';
import {setSentryUser} from 'utils/sentry';

export const SentryUserSetter = () => {
    const currentUser = useAppSelector(getCurrentUser);

    useEffect(() => {
        if (!currentUser) {
            return;
        }

        const {id, username} = currentUser;
        setSentryUser({id, username});
    }, [currentUser]);

    return null;
};
